// Dependency hint. Two presentations of the same blocked-by information,
// per the design review Pass 7 decision:
//
//   - Banner (top of task detail): "等 [Task X 标题] 完成后可开始 →"
//     amber tinted with chain icon, full-width.
//
//   - Inline (under due date on TaskCard): "等 X 完成" muted small text.
//
// Wraps lib/dependencies.ts isBlocked check; never re-implements logic.

import { Icon } from './Icon.jsx';
import { isBlocked } from '../lib/dependencies.ts';
import { navigate } from '../lib/routing.js';

/** Banner used at the top of TaskDetail when this task is currently blocked. */
export const DependencyHintBanner = ({ task, allTasks }) => {
  if (!isBlocked(task, allTasks)) return null;
  const blockers = (task.blockedBy || [])
    .map(id => allTasks.find(t => t.id === id))
    .filter(Boolean)
    .filter(b => b.status !== '已完成' && b.status !== '已取消');
  if (blockers.length === 0) return null;
  return (
    <div className="vava-alert amber" role="status" aria-label="此待办被依赖阻塞">
      <div className="left">
        <Icon name="alert" className="icon"/>
        <span>
          {blockers.length === 1
            ? <>等 <strong>{blockers[0].title}</strong> 完成后可开始</>
            : <>等 <strong>{blockers.length}</strong> 个待办完成后可开始：{blockers.map(b => b.title).join('、')}</>}
        </span>
      </div>
      <button className="action" onClick={(e) => { e.preventDefault(); navigate('/task/' + blockers[0].id); }}>
        查看 →
      </button>
    </div>
  );
};

/** Inline hint shown under the due-date on a kanban TaskCard. */
export const DependencyHintInline = ({ task, allTasks }) => {
  if (!isBlocked(task, allTasks)) return null;
  const blocker = (task.blockedBy || [])
    .map(id => allTasks.find(t => t.id === id))
    .filter(Boolean)
    .find(b => b.status !== '已完成' && b.status !== '已取消');
  if (!blocker) return null;
  // Truncate long titles so the card stays compact.
  const shortTitle = blocker.title.length > 14 ? blocker.title.slice(0, 14) + '…' : blocker.title;
  return (
    <span className="dep-hint-inline" title={`Waiting on: ${blocker.title}`}>
      等 {shortTitle} 完成
    </span>
  );
};
